/* NUSA · LIVING DESIGN — Personalización en la ficha de producto: selector de tela, color y acabado,
   vista previa sobre la foto (en las piezas que la tienen), campos del pedido y mensaje de WhatsApp.
   Datos: window.NUSA_PALETAS (assets/nusa-paletas.js). Motor de la vista previa: assets/nusa-motor.js (se carga solo si hace falta). */
(function () {
  'use strict';
  var D = window.NUSA_PALETAS;
  var root = document.querySelector('[data-nusa-pz]');
  if (!D || !root) return;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var ESC = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ESC[c]; }); };
  var norm = function (s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); };

  var cfg = {
    handle: root.dataset.handle || '',
    title: root.dataset.title || '',
    pal: (root.dataset.pal || '').split(',').filter(Boolean),   // tela, alu, cer
    struct: root.dataset.struct || '',                          // 'choice' (teca o aluminio) | 'variant' (lo resuelve la variante de Shopify) | ''
    prev: root.dataset.prev || '',                              // 'bali' | 'cies' | '' (pieza con vista previa sobre la foto)
    motor: root.dataset.motor || '',
    pieceUrl: root.dataset.pieza || '',                         // datos (mapa de capas) de la pieza: assets/nusa-pz-<handle>.json
    stock: root.dataset.stock === 'true',                       // pieza con la etiqueta "Entrega Inmediata": la de las fotos está lista; otra tela o color pasa a hacerse bajo pedido
    plazo: root.dataset.plazo || '8-16 semanas',                // plazo de fabricación bajo pedido (el de la ficha)
    wa: '50761613851'
  };
  var LISTS = { tela: D.tela, alu: D.alu, cer: D.cer };
  // piezas con vista previa por mapa de capas (todas menos Bali y Cies, que llevan su propia segmentación en el motor): { l: 'FA', k: 'tela' | 'cer' }
  // l = capas que cambian en la foto: F tela, C cubierta de cerámica, A aluminio
  var PZ = (D.piezas && D.piezas[cfg.handle]) || null;
  if (PZ && !cfg.prev && cfg.pieceUrl) cfg.prev = 'pieza'; else PZ = cfg.prev === 'pieza' ? PZ : null;
  function hasLayer(l) { return !!(PZ && PZ.l.indexOf(l) >= 0); }
  // telas con imagen propia (PZ.t = { idTela: archivo }): la foto de la pieza en esa tela es una imagen hecha aparte (con IA) que se muestra tal cual y el motor
  // solo recolorea el aluminio encima. PZ.e === 0: en esta pieza solo se ofrecen las telas que tienen imagen; si no, las demás siguen con el motor de capas.
  var TI = (PZ && PZ.t) || null;
  function hasTI(id) { return !!(TI && id && TI[id]); }
  function tUrl(v) { return /^(https?:)?\/\/|^\//.test(v) ? v : D.base + v; }
  var TXT = {
    tela: { label: 'Tela', all: 'Ver todas las telas', drawer: 'Todas las telas', noun: 'telas', search: 'Buscar por nombre o código', note: 'Colores aproximados, tomados de la foto de cada muestra. Pide la muestra física para confirmar.' },
    alu: { label: 'Color del aluminio', all: 'Ver todos los colores', drawer: 'Colores de aluminio', noun: 'colores', search: 'Buscar por nombre o código', note: 'Colores aproximados, tomados de una foto de la muestra. Pide la muestra física para confirmar.' },
    cer: { label: 'Cubierta de cerámica', all: 'Ver todas las cubiertas', drawer: 'Cubiertas de cerámica', noun: 'cubiertas', search: 'Buscar por código o nombre', note: 'Identificamos cada cubierta por su código; el nombre es una descripción de lo que se ve en la muestra.' }
  };
  var S = { st: null, tela: null, alu: null, cer: null, orig: false, free: false };   // orig: ver la foto original; free: galería liberada ("Ver otras fotos")
  var lastPhoto = null;     // última muestra con foto elegida (tela o cubierta), para el recuadro "de cerca"

  /* ---------------- datos ---------------- */
  function find(kind, id) { var l = LISTS[kind]; for (var i = 0; i < l.length; i++) { if (l[i].id === id) return l[i]; } return null; }
  function findAny(kind, v) {
    if (!v) return null; var q = String(v).toLowerCase(), l = LISTS[kind];
    for (var i = 0; i < l.length; i++) { if (l[i].id === q || String(l[i].c).toLowerCase() === q) return l[i]; }
    return null;
  }
  // las telas "solo imagen" (it.io) no se pueden dibujar con el motor de capas: solo se ven en las piezas que tienen su imagen
  function engineOK(id) { var it = id && find('tela', id); return !!(it && !it.io); }
  // lo que se ofrece en pantalla (puntos y cajón): en las piezas con imágenes de tela y PZ.e === 0, solo las telas que tienen imagen
  function uiList(kind) {
    var l = LISTS[kind];
    if (kind === 'tela' && TI && PZ.e === 0) l = l.filter(function (it) { return hasTI(it.id); });
    return l;
  }
  // puntos de color de cada opción: en las piezas con imágenes de tela van primero las telas que tienen imagen
  function uiFeat(kind) {
    var f = D.feat[kind].slice();
    if (kind !== 'tela' || !TI) return f;
    var own = LISTS.tela.filter(function (it) { return hasTI(it.id); }).map(function (it) { return it.id; });
    if (PZ.e === 0) return own.slice(0, 8);
    return own.concat(f.filter(function (id) { return own.indexOf(id) < 0; })).slice(0, 8);
  }
  function imgUrl(it, w) { return D.base + it.i + (w ? '?width=' + w : ''); }
  function shade(hex, amt) {
    var n = parseInt(hex.slice(1), 16), r = n >> 16 & 255, g = n >> 8 & 255, b = n & 255;
    var f = function (c) { return Math.round(amt >= 0 ? c + (255 - c) * amt : c * (1 + amt)); };
    return 'rgb(' + f(r) + ',' + f(g) + ',' + f(b) + ')';
  }
  function bg(kind, it, w) {
    if (kind === 'alu') return 'background:linear-gradient(125deg,' + shade(it.x, 0.1) + ' 0%,' + it.x + ' 45%,' + shade(it.x, -0.1) + ' 100%)';
    return 'background-color:' + it.x + ';background-image:url(' + imgUrl(it, w) + ');background-size:cover;background-position:center';
  }
  function primary(kind, it) { return kind === 'cer' ? it.c : it.n; }
  function secondary(kind, it) { if (kind === 'cer') return it.n; if (kind === 'alu') return it.k ? '' : it.c; return it.c; }
  function plain(kind, it) { var s = secondary(kind, it); return primary(kind, it) + (s ? ' · ' + s : ''); }
  function aluVisible() {
    if (cfg.pal.indexOf('alu') < 0) return false;
    if (cfg.struct === 'choice') return S.st === 'aluminio';
    if (cfg.struct === 'variant') {
      var act = $('[data-swatch].is-active'), label = act ? String(act.dataset.variantLabel || '').toLowerCase() : '';
      return !act || label.indexOf('luminio') >= 0;
    }
    return true;
  }

  // ¿el cliente eligió algo distinto a "como en la foto"?
  function isCustom() { return !!(S.tela || S.cer || (S.alu && aluVisible()) || (cfg.struct === 'choice' && S.st)); }
  // piezas de entrega inmediata: con una elección pasan a "hecha bajo pedido" (aviso de arriba y nota de compra; los dos textos vienen ya escritos en main-product.liquid)
  function syncStock() {
    if (!cfg.stock) return;
    var custom = isCustom();
    $$('[data-pz-stock-badge], [data-pz-stock-note]').forEach(function (el) { el.hidden = custom; });
    $$('[data-pz-order-badge], [data-pz-order-note]').forEach(function (el) { el.hidden = !custom; });
  }
  // en las piezas con vista previa, mientras haya una elección la galería queda fija en la foto principal (las demás fotos no cambian de color); "Ver otras fotos" la libera
  function syncLock() {
    if (!gal) return;
    gal.classList.toggle('nusa-pz-locked', !!(cfg.prev && !PV.failed && wantsPreview() && !S.free));
  }
  function goMain() {
    var th = $$('[data-gallery-thumb]', gal);
    if (th.length && !th[0].classList.contains('is-active')) th[0].click();   // nusa.js cambia la foto y marca la miniatura
  }

  /* ---------------- WhatsApp ---------------- */
  function selectionText() {
    var parts = [], it;
    if (cfg.struct === 'choice' && S.st) parts.push('estructura en ' + (S.st === 'teca' ? 'teca' : 'aluminio'));
    if (S.tela && (it = find('tela', S.tela))) parts.push('tela ' + it.n + ' (ref. ' + it.c + ')');
    if (S.cer && (it = find('cer', S.cer))) parts.push('cubierta ' + it.c + ' (' + it.n + ')');
    if (S.alu && aluVisible() && (it = find('alu', S.alu))) parts.push('aluminio ' + it.n + (it.k ? '' : ' (ref. ' + it.c + ')'));
    return parts.join(', ');
  }
  function waLink(text) { return 'https://wa.me/' + cfg.wa + '?text=' + encodeURIComponent(text); }
  function waMain() {
    var sel = selectionText();
    return waLink(sel ? 'Hola, me interesa ' + cfg.title + ' con ' + sel + '. ¿Me ayudan con la cotización?' : 'Hola, quisiera personalizar el producto "' + cfg.title + '" (tela, color y acabado).');
  }
  function waSample(kind, it) {
    var what = kind === 'tela' ? 'la tela' : kind === 'cer' ? 'la cubierta' : 'el aluminio';
    return waLink('Hola, quisiera una muestra de ' + what + ' ' + primary(kind, it) + (it.k ? '' : ' (ref. ' + it.c + ')') + ' para ' + cfg.title + '.');
  }

  /* ---------------- bloque del selector ---------------- */
  function dotsHTML(kind) {
    var feat = uiFeat(kind), sel = S[kind];
    if (sel && feat.indexOf(sel) < 0) feat = [sel].concat(feat.slice(0, -1));
    return feat.map(function (id) {
      var it = find(kind, id), t = esc(plain(kind, it));
      return '<button type="button" class="nusa-pz__dot" data-act="pick" data-kind="' + kind + '" data-id="' + id + '" aria-pressed="' + (sel === id) + '" aria-label="' + t + '" title="' + t + '" style="' + bg(kind, it, 96) + '"></button>';
    }).join('');
  }
  function pickedHTML(kind) {
    var it = S[kind] && find(kind, S[kind]); if (!it) return '';
    var sec = secondary(kind, it);
    return '<div class="nusa-pz__picked"><span class="nusa-pz__chip' + (kind === 'alu' ? ' is-flat' : '') + '" style="' + bg(kind, it, 160) + '" aria-hidden="true"></span><div><strong>' + esc(primary(kind, it)) + '</strong>' +
      (sec ? '<span class="nusa-pz__meta">' + esc(sec) + '</span>' : '<span class="nusa-pz__meta">Código por confirmar</span>') +
      '<a class="nusa-pz__link" href="' + waSample(kind, it) + '" target="_blank" rel="noopener" data-pz-track="whatsapp_click" data-pz-source="muestra" data-pz-product="' + esc(cfg.title) + '">Pedir muestra física</a></div></div>';
  }
  function optHTML(kind) {
    var it = S[kind] && find(kind, S[kind]), hidden = kind === 'alu' && !aluVisible();
    return '<div class="nusa-pz__opt" data-opt="' + kind + '"' + (hidden ? ' hidden' : '') + '>' +
      '<div class="nusa-pz__opt-h"><span class="nusa-pz__lab">' + TXT[kind].label + '</span><span class="nusa-pz__val">' + (it ? esc(primary(kind, it)) : 'Como en la foto') + '</span></div>' +
      '<div class="nusa-pz__dots" role="group" aria-label="' + TXT[kind].label + '">' + dotsHTML(kind) + '</div>' +
      '<button type="button" class="nusa-pz__more" data-act="open" data-kind="' + kind + '">' + TXT[kind].all + ' &rarr;</button>' + pickedHTML(kind) + noPvHTML(kind) + '</div>';
  }
  // en las piezas con vista previa, lo que no cambia en la foto se avisa en cuanto el cliente elige (no queda la duda de si "no funciona")
  function noPvHTML(kind) {
    if (cfg.prev !== 'pieza' || !S[kind]) return '';
    var has = kind === 'tela' ? (hasTI(S.tela) || (hasLayer('F') && engineOK(S.tela))) : kind === 'cer' ? hasLayer('C') : kind === 'alu' ? hasLayer('A') : true;
    return has ? '' : '<p class="nusa-pz__nopv">En la foto de esta pieza no se ve este cambio; tu elección queda guardada con el pedido.</p>';
  }
  function structHTML() {
    var v = S.st, teca = D.teca;
    return '<div class="nusa-pz__opt" data-opt="st"><div class="nusa-pz__opt-h"><span class="nusa-pz__lab">Estructura <em>(a elección)</em></span><span class="nusa-pz__val">' + (v ? (v === 'teca' ? 'Teca' : 'Aluminio') : 'Elige una') + '</span></div>' +
      '<div class="nusa-pz__choices" role="group" aria-label="Estructura">' +
      '<button type="button" class="nusa-pz__choice" data-act="struct" data-v="teca" aria-pressed="' + (v === 'teca') + '">Teca</button>' +
      '<button type="button" class="nusa-pz__choice" data-act="struct" data-v="aluminio" aria-pressed="' + (v === 'aluminio') + '">Aluminio</button></div>' +
      (v === 'teca' ? '<div class="nusa-pz__picked"><span class="nusa-pz__chip" style="background-image:url(' + imgUrl(teca, 160) + ');background-size:cover;background-position:center" aria-hidden="true"></span><div><strong>' + esc(teca.n) + '</strong><span class="nusa-pz__meta">' + esc(teca.c) + '</span></div></div>' : '') +
      '<p class="nusa-pz__err" data-err hidden>Elige la estructura: teca o aluminio.</p></div>';
  }
  function noteText() {
    return cfg.prev ? 'La foto de la pieza cambia con tu elección. Es una vista previa aproximada: el color real se confirma con tu pedido.'
      : 'Tu elección queda guardada con el pedido. Los colores en pantalla son aproximados: pide la muestra física para confirmar.';
  }
  function blockHTML() {
    var parts = [];
    if (cfg.struct === 'choice') parts.push(structHTML());
    cfg.pal.forEach(function (k) { parts.push(optHTML(k)); });
    return '<div class="nusa-pz__box"><div><p class="nusa-pz__title">Personaliza tu pieza</p><p class="nusa-pz__lead">Elige tela y acabado entre nuestras opciones. Tu elección queda guardada con el pedido y la confirmamos contigo antes de fabricar.</p>' +
      '<p class="nusa-pz__lead nusa-pz__lead--alt">Elige tela, color y acabado entre nuestras opciones. Te asesoramos por WhatsApp o en el showroom antes de confirmar tu pedido.</p>' +
      (cfg.stock ? '<p class="nusa-pz__stock"><strong>La pieza de las fotos es de entrega inmediata (3–7 días).</strong> Si la quieres en otra tela, color o acabado, se fabrica bajo pedido: ' + esc(cfg.plazo) + '.</p>' : '') + '</div>' +
      parts.join('') + '<p class="nusa-pz__note">' + noteText() + '</p>' +
      '<div class="nusa-pz__actions"><a class="nusa-btn nusa-btn--dark nusa-btn--sm" data-pz-wa href="' + waMain() + '" target="_blank" rel="noopener" data-pz-track="whatsapp_click" data-pz-source="personalizar" data-pz-product="' + esc(cfg.title) + '">Personalizar con asesoría &rarr;</a>' +
      '<a class="nusa-custom-box__link" href="/pages/materiales">Cómo funciona</a></div></div>';
  }
  // si en la variante activa no queda ninguna opción visible (p. ej. aluminio con la variante "teca"), el bloque vuelve al texto de siempre
  function syncEmpty() {
    var box = $('.nusa-pz__box', root); if (!box) return;
    box.classList.toggle('is-empty', !$$('.nusa-pz__opt', root).some(function (o) { return !o.hidden; }));
  }
  function refresh(kind, focusId) {
    var el = $('[data-opt="' + kind + '"]', root); if (!el) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = kind === 'st' ? structHTML() : optHTML(kind);
    el.parentNode.replaceChild(tmp.firstChild, el);
    syncEmpty();
    if (focusId) { var b = $('[data-opt="' + kind + '"] [data-id="' + focusId + '"]', root) || $('[data-opt="' + kind + '"] [data-v="' + focusId + '"]', root); if (b) b.focus(); }
  }
  function refreshAll() {
    if (cfg.struct === 'choice') refresh('st');
    cfg.pal.forEach(function (k) { refresh(k); });
    var wa = $('[data-pz-wa]', root); if (wa) wa.href = waMain();
  }

  /* ---------------- campos del pedido, URL, avisos ---------------- */
  var form = $('form.nusa-cart-form') || $('form[action*="/cart/add"]');
  function fieldsBox() {
    if (!form) return null;
    var box = $('[data-nusa-pz-fields]', form);
    if (!box) { box = document.createElement('div'); box.setAttribute('data-nusa-pz-fields', ''); box.hidden = true; form.appendChild(box); }
    return box;
  }
  function syncFields() {
    var box = fieldsBox(); if (!box) return;
    var rows = [], it;
    if (cfg.struct === 'choice' && S.st) rows.push(['Estructura', S.st === 'teca' ? 'Teca' : 'Aluminio']);
    if (S.tela && (it = find('tela', S.tela))) { rows.push(['Tela', it.n]); rows.push(['Código de la tela', it.c]); }
    if (S.cer && (it = find('cer', S.cer))) { rows.push(['Cubierta', it.n]); rows.push(['Código de la cubierta', it.c]); }
    if (S.alu && aluVisible() && (it = find('alu', S.alu))) { rows.push(['Color del aluminio', it.n]); rows.push(['Código del aluminio', it.c + (it.k ? ' (por confirmar)' : '')]); }
    // pieza de entrega inmediata personalizada: queda anotado en el pedido (y en el correo de confirmación) que ya no es entrega inmediata
    if (cfg.stock && isCustom()) rows.push(['Plazo', 'Hecho bajo pedido, ' + cfg.plazo]);
    box.innerHTML = rows.map(function (r) { return '<input type="hidden" name="properties[' + esc(r[0]) + ']" value="' + esc(r[1]) + '">'; }).join('');
  }
  var URLKEY = { tela: 'tela', alu: 'aluminio', cer: 'cubierta' };
  function syncURL() {
    try {
      var u = new URL(window.location.href);
      ['tela', 'aluminio', 'cubierta', 'estructura'].forEach(function (k) { u.searchParams.delete(k); });
      if (cfg.struct === 'choice' && S.st) u.searchParams.set('estructura', S.st);
      ['tela', 'alu', 'cer'].forEach(function (k) { var it = S[k] && find(k, S[k]); if (it && (k !== 'alu' || aluVisible())) u.searchParams.set(URLKEY[k], it.c); });
      window.history.replaceState(null, '', u.pathname + u.search + u.hash);
    } catch (e) { /* sin historial: no pasa nada */ }
  }
  function track(kind, it) {
    if (window.dataLayer && typeof window.dataLayer.push === 'function') window.dataLayer.push({ event: 'personaliza_elegir', tipo: kind, codigo: it ? it.c : '', producto: cfg.handle });
  }

  /* ---------------- recuadro "de cerca" sobre la foto ---------------- */
  var gal = $('[data-product-gallery]'), mainBox = gal && $('.nusa-gallery__main', gal), mainImg = gal && $('[data-gallery-main]', gal);
  function updateInset() {
    if (!mainBox) return;
    var kind = lastPhoto && S[lastPhoto] ? lastPhoto : (S.tela ? 'tela' : S.cer ? 'cer' : null), it = null, cap = '';
    if (kind) { it = find(kind, S[kind]); cap = kind === 'tela' ? 'Tu tela, de cerca' : 'Tu cubierta, de cerca'; }
    else if (S.alu && aluVisible()) { kind = 'alu'; it = find('alu', S.alu); cap = 'Tu aluminio'; }
    var el = $('.nusa-pz-inset', mainBox);
    if (!it) { if (el) el.parentNode.removeChild(el); return; }
    if (!el) { el = document.createElement('div'); el.className = 'nusa-pz-inset'; mainBox.appendChild(el); }
    el.innerHTML = '<span class="nusa-pz-inset__img" style="' + bg(kind, it, 240) + '"></span><span class="nusa-pz-inset__cap">' + cap + '</span>';
  }

  /* ---------------- vista previa sobre la foto (solo piezas con foto base preparada) ---------------- */
  var PV = { prep: null, texs: {}, order: [], cache: {}, ckeys: [], timg: {}, torder: [], sw: {}, sworder: [], tok: 0, failed: false, shown: false, on: false, status: '', cv: null, bar: null };
  function loadImg(url) { return new Promise(function (res, rej) { var i = new Image(); i.crossOrigin = 'anonymous'; i.onload = function () { res(i); }; i.onerror = function () { rej(new Error('imagen')); }; i.src = url; }); }
  function loadScript(url) { return new Promise(function (res, rej) { var s = document.createElement('script'); s.src = url; s.async = true; s.onload = res; s.onerror = function () { rej(new Error('motor')); }; document.head.appendChild(s); }); }
  // mapa de capas: varias corridas (largo << 3 | etiqueta) en varint (7 bits por byte), en base64
  function decodeRLE(b64) {
    var bin = atob(b64), n = 800 * 1000, lab = new Uint8Array(n), i = 0, p = 0;
    while (p < bin.length && i < n) {
      var v = 0, mul = 1, b;
      do { b = bin.charCodeAt(p++); v += (b & 127) * mul; mul *= 128; } while (b & 128);
      var k = v % 8, len = Math.floor(v / 8); lab.fill(k, i, Math.min(n, i + len)); i += len;
    }
    return lab;
  }
  function warm() {
    if (!cfg.prev || PV.failed || !mainBox) return Promise.reject(new Error('sin vista previa'));
    if (PZ && PZ.n) return Promise.reject(new Error('sin mapa de capas'));   // pieza solo con imágenes de tela: no hay motor que preparar
    if (!PV.prep && cfg.prev === 'pieza') {
      PV.prep = (function () {
        var motor = window.NusaPV ? Promise.resolve() : loadScript(cfg.motor);
        var datos = fetch(cfg.pieceUrl).then(function (r) { if (!r.ok) throw new Error('datos'); return r.json(); });
        return Promise.all([motor, loadImg(D.base + 'nusa-base-' + cfg.handle + '.jpg'), datos]).then(function (v) {
          var c = document.createElement('canvas'); c.width = window.NusaPV.W; c.height = window.NusaPV.H;
          var x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(v[1], 0, 0, c.width, c.height);
          return window.NusaPV.prepareLabels(x.getImageData(0, 0, c.width, c.height), decodeRLE(v[2].lab), Object.assign({},v[2].cfg||{},{fabricAlbedo:D.fabricAlbedo&&D.fabricAlbedo[cfg.handle],fabricSurfaces:D.fabricSurfaces&&D.fabricSurfaces[cfg.handle]}));
        });
      })();
      PV.prep.catch(function () { PV.failed = true; });
    }
    if (!PV.prep) {
      PV.prep = (function () {
        return (window.NusaPV ? Promise.resolve() : loadScript(cfg.motor)).then(function () { return loadImg(D.base + D.prev[cfg.prev]); }).then(function (img) {
          var c = document.createElement('canvas'); c.width = window.NusaPV.W; c.height = window.NusaPV.H;
          var x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(img, 0, 0, c.width, c.height);
          return window.NusaPV.prepare(cfg.prev, x.getImageData(0, 0, c.width, c.height));
        });
      })();
      PV.prep.catch(function () { PV.failed = true; });
    }
    return PV.prep;
  }
  function texture(kind, it, P) {
    var meta = D.fabricSurfaces && D.fabricSurfaces[cfg.handle];
    if (meta) P.surfaces = meta;
    var key = kind + ':' + it.id;
    if (kind === 'tela' && it.finish === 'smooth') {
      if (!PV.texs[key]) PV.texs[key] = Promise.resolve(window.NusaPV.flatTex(it.x, 0));
      return PV.texs[key];
    }
    if (!PV.texs[key]) {
      PV.texs[key] = loadImg(imgUrl(it)).then(function (img) {
        var t;
        if (kind === 'tela') {
          t = window.NusaPV.imageTex(img, P.pxcm * (it.cm || 9.5) / 256, {pxcm:P.pxcm,repeatCm:it.rp,pattern:it.pattern,surface:it.surface});
          if (t.centerOn) t.centerOn(P.cxF);
        } else {
          t = window.NusaPV.stoneTex(img, P.pxcm, it.w, it.h, P.plane);
        }
        return t;
      });
      PV.texs[key].catch(function () { delete PV.texs[key]; });   // si la muestra no cargó, la próxima vez se vuelve a intentar
      if (kind === 'cer') {      // cada cubierta sintetizada pesa unos 5 MB: se guardan solo las 3 últimas
        PV.order = PV.order.filter(function (k) { return k !== key; }); PV.order.push(key);
        while (PV.order.length > 3) delete PV.texs[PV.order.shift()];
      }
    }
    return PV.texs[key];
  }
  function ensureUI() {
    if (PV.cv) return;
    var cv = document.createElement('canvas'); cv.width = 800; cv.height = 1000; cv.className = 'nusa-pz-canvas'; cv.hidden = true;
    cv.setAttribute('role', 'img'); cv.setAttribute('aria-label', 'Vista previa de ' + cfg.title + ' con tu elección');
    mainBox.appendChild(cv); PV.cv = cv;
    var bar = document.createElement('div'); bar.className = 'nusa-pz-prevbar'; bar.hidden = true;
    bar.innerHTML = '<p class="nusa-pz-prevbar__note">Vista previa aproximada. <span data-pz-status></span></p>' +
      '<span class="nusa-pz-prevbar__links"><button type="button" class="nusa-pz__link" data-pz-toggle>Ver foto original</button><button type="button" class="nusa-pz__link" data-pz-free>Ver otras fotos</button></span>';
    var after = $('.nusa-gallery__thumbs', gal) || mainBox;
    after.parentNode.insertBefore(bar, after.nextSibling); PV.bar = bar;
    bar.addEventListener('click', function (e) {
      if (e.target.closest('[data-pz-toggle]')) { S.orig = !S.orig; setView(); }
      else if (e.target.closest('[data-pz-free]')) { S.free = !S.free; if (!S.free) { S.orig = false; goMain(); } syncLock(); setView(); }
    });
    ensureMini();
  }
  /* miniatura flotante: cuando la foto queda fuera de pantalla (en el teléfono el selector está bastante más abajo), se sigue viendo el resultado; al tocarla sube a la foto */
  var MINI = { el: null, cv: null, galOut: false, boxIn: false };
  function ensureMini() {
    if (MINI.el || !('IntersectionObserver' in window)) return;
    var b = document.createElement('button'); b.type = 'button'; b.className = 'nusa-pz-mini'; b.hidden = true;
    b.setAttribute('aria-label', 'Ver la vista previa de tu pieza');
    var c = document.createElement('canvas'); c.width = 160; c.height = 200; b.appendChild(c);
    document.body.appendChild(b); MINI.el = b; MINI.cv = c;
    b.addEventListener('click', function () { mainBox.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' }); });
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.target === mainBox) MINI.galOut = !e.isIntersecting; else MINI.boxIn = e.isIntersecting; });
      syncMini();
    });
    io.observe(mainBox); io.observe(root);
  }
  function syncMini() {
    if (!MINI.el) return;
    var on = !!PV.on && MINI.galOut && MINI.boxIn;
    MINI.el.hidden = !on;
    if (on && PV.cv) MINI.cv.getContext('2d').drawImage(PV.cv, 0, 0, MINI.cv.width, MINI.cv.height);
  }
  function setStatus(t) { PV.status = t || ''; var el = PV.bar && $('[data-pz-status]', PV.bar); if (el) el.textContent = PV.status; }
  function firstThumbActive() { var th = $$('[data-gallery-thumb]', gal); return !th.length || th[0].classList.contains('is-active'); }
  function setView() {
    if (!PV.cv || PV.failed) return;
    var on = PV.shown && firstThumbActive() && !S.orig;
    PV.on = on;
    PV.cv.hidden = !on; if (mainImg) mainImg.hidden = on;
    PV.bar.hidden = !(PV.shown || PV.status);                 // la barra aparece en cuanto hay algo que contar ("Calculando…") y se va si ya no hay vista previa
    var links = $('.nusa-pz-prevbar__links', PV.bar); if (links) links.hidden = !PV.shown;
    var btn = $('[data-pz-toggle]', PV.bar); if (btn) btn.textContent = S.orig ? 'Ver vista previa' : 'Ver foto original';
    var fr = $('[data-pz-free]', PV.bar); if (fr) fr.textContent = S.free ? 'Volver a mi vista previa' : 'Ver otras fotos';
    syncMini();
  }
  // si el navegador no puede generar la vista previa se dice, en lugar de dejar la foto igual sin explicación; la elección sí queda guardada con el pedido
  function failUI() {
    if (PV.bar) { PV.bar.innerHTML = '<p class="nusa-pz-prevbar__note">No pudimos mostrar la vista previa en este navegador. Tu elección sí queda guardada con el pedido.</p>'; PV.bar.hidden = false; }
    if (PV.cv) PV.cv.hidden = true;
    if (mainImg) mainImg.hidden = false;
    PV.on = false; syncMini(); syncLock();
  }
  function wantsPreview() {
    if (cfg.prev === 'pieza') return !!((S.tela && (hasTI(S.tela) || (hasLayer('F') && engineOK(S.tela)))) || (hasLayer('C') && S.cer) || (hasLayer('A') && S.alu && aluVisible()));
    return cfg.prev === 'bali' ? !!(S.tela || (S.st === 'aluminio' && S.alu)) : !!(S.cer || S.alu);
  }
  /* ---- telas con imagen propia ---- */
  function setCanvas(w, h) { if (PV.cv.width !== w) PV.cv.width = w; if (PV.cv.height !== h) PV.cv.height = h; }
  function tImage(id) {
    if (!PV.timg[id]) {
      PV.timg[id] = loadImg(tUrl(TI[id]));
      PV.timg[id].catch(function () { delete PV.timg[id]; });
      PV.torder = PV.torder.filter(function (k) { return k !== id; }); PV.torder.push(id);
      while (PV.torder.length > 6) delete PV.timg[PV.torder.shift()];
    }
    return PV.timg[id];
  }
  // la imagen de la tela tal cual, en el lienzo y a su tamaño (como mucho 1000 x 1250, 4:5)
  function drawPhoto(img) {
    var w = Math.min(img.naturalWidth || 800, 1000), h = Math.round(w * 1.25);
    setCanvas(w, h); var g = PV.cv.getContext('2d'); g.imageSmoothingQuality = 'high'; g.drawImage(img, 0, 0, w, h);
  }
  // imagen de la tela + aluminio recoloreado: el motor calcula a 800 x 1000 (capas de la foto del catálogo, píxeles de la imagen de la tela) y solo lo que es
  // aluminio se pone encima de la imagen original, que conserva toda su nitidez. Así no hace falta preparar capas para cada imagen de tela.
  function drawAlu(P, img, hex, id) {
    var NP = window.NusaPV, W = NP.W, H = NP.H, N = W * H, sw = PV.sw[id];
    if (!sw) {
      var c = document.createElement('canvas'); c.width = W; c.height = H;
      var x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(img, 0, 0, W, H);
      sw = Object.assign({}, P, { base: new Uint8ClampedArray(x.getImageData(0, 0, W, H).data) });
      PV.sw[id] = sw; PV.sworder = PV.sworder.filter(function (k) { return k !== id; }); PV.sworder.push(id);
      while (PV.sworder.length > 3) delete PV.sw[PV.sworder.shift()];
    }
    var out = NP.compose(sw, null, hex), d = out.data, a = P.aA;
    for (var i = 0; i < N; i++) d[4 * i + 3] = a[i] > 0.004 ? 255 : 0;
    var ov = document.createElement('canvas'); ov.width = W; ov.height = H; ov.getContext('2d').putImageData(out, 0, 0);
    drawPhoto(img);
    var g = PV.cv.getContext('2d'); g.imageSmoothingQuality = 'high'; g.drawImage(ov, 0, 0, PV.cv.width, PV.cv.height);
  }
  function renderPreview() {
    if (!cfg.prev || PV.failed || !mainBox) return;
    if (!wantsPreview()) { ++PV.tok; if (PV.cv) { PV.shown = false; setStatus(''); setView(); } return; }   // ++tok: descarta un cálculo en curso que llegaría después de quitar la elección
    ensureUI();
    var token = ++PV.tok;
    if (!PV.last) setStatus('Calculando…');
    setView();
    var ti = cfg.prev === 'pieza' && hasTI(S.tela) ? S.tela : null;
    if (ti && !(hasLayer('A') && S.alu && aluVisible())) {      // solo la imagen de esa tela: no hace falta el motor
      tImage(ti).then(function (img) {
        if (token !== PV.tok) return;
        drawPhoto(img); PV.last = true; PV.shown = true; setStatus(''); setView();
      }, function () { if (token !== PV.tok) return; setStatus('No se pudo cargar esa tela; prueba de nuevo.'); setView(); });
      return;
    }
    warm().then(function (P) {
      var tx = null, hex = null, jobs = [], timg = null;
      if (cfg.prev === 'pieza') {
        if (ti) jobs.push(tImage(ti).then(function (i) { timg = i; }));
        else if (hasLayer('F') && S.tela && engineOK(S.tela)) jobs.push(texture('tela', find('tela', S.tela), P).then(function (t) { tx = t; }));
        if (hasLayer('C') && S.cer) jobs.push(texture('cer', find('cer', S.cer), P).then(function (t) { tx = t; }));
        if (hasLayer('A') && S.alu && aluVisible()) {
          var chosenAlu = find('alu', S.alu);
          hex = chosenAlu.x;
        }
      } else if (cfg.prev === 'bali') {
        if (S.tela) jobs.push(texture('tela', find('tela', S.tela), P).then(function (t) { tx = t; }));
        if (S.st === 'aluminio' && S.alu) hex = find('alu', S.alu).x;
      } else {
        if (S.cer) jobs.push(texture('cer', find('cer', S.cer), P).then(function (t) { tx = t; }));
        if (S.alu) hex = find('alu', S.alu).x;
      }
      return Promise.all(jobs).then(function () {
        if (token !== PV.tok) return;
        if (timg) { drawAlu(P, timg, hex, ti); PV.last = true; PV.shown = true; setStatus(''); setView(); return; }
        var key = [S.tela, S.st, S.alu, S.cer, aluVisible() ? 1 : 0].join('|'), data = PV.cache[key];
        if (!data) { data = window.NusaPV.compose(P, tx, hex); PV.cache[key] = data; PV.ckeys.push(key); if (PV.ckeys.length > 8) delete PV.cache[PV.ckeys.shift()]; }
        PV.last = data; setCanvas(window.NusaPV.W, window.NusaPV.H); PV.cv.getContext('2d').putImageData(data, 0, 0); PV.shown = true; setStatus(''); setView();
      }, function () {
        if (token !== PV.tok) return;
        setStatus('No se pudo cargar esa muestra; prueba de nuevo.'); setView();
      });
    }).catch(function () { PV.failed = true; PV.shown = false; failUI(); });
  }

  /* ---------------- cajón "ver todas" ---------------- */
  var drawer = null, dr = { kind: '', q: '', fam: '' }, lastFocus = null;
  function families(kind) { var seen = {}, out = []; uiList(kind).forEach(function (it) { if (it.f && !seen[it.f]) { seen[it.f] = 1; out.push(it.f); } }); return out; }
  function filtered() {
    var q = norm(dr.q.trim());
    return uiList(dr.kind).filter(function (it) {
      return (!q || norm(it.n + ' ' + it.c).indexOf(q) >= 0) && (!dr.fam || it.f === dr.fam);
    });
  }
  function paintDrawer() {
    var kind = dr.kind, list = filtered(), fams = families(kind);
    var chips = fams.length > 1 ? '<button type="button" class="nusa-pz-chip" data-dr="fam" data-v="" aria-pressed="' + (dr.fam === '') + '">Todos los colores</button>' +
      fams.map(function (f) { return '<button type="button" class="nusa-pz-chip" data-dr="fam" data-v="' + esc(f) + '" aria-pressed="' + (dr.fam === f) + '">' + esc(f) + '</button>'; }).join('') : '';
    $('[data-chips]', drawer).innerHTML = chips;
    $('[data-count]', drawer).textContent = list.length + ' de ' + uiList(kind).length + ' ' + TXT[kind].noun;
    $('[data-grid]', drawer).innerHTML = list.length ? list.map(function (it) {
      var sec = secondary(kind, it);
      return '<button type="button" class="nusa-pz-tile" data-dr="pick" data-id="' + it.id + '" aria-pressed="' + (S[kind] === it.id) + '">' +
        '<span class="nusa-pz-tile__img' + (kind === 'cer' ? ' is-flat' : '') + '" style="' + bg(kind, it, 240) + '"></span>' +
        '<span class="nusa-pz-tile__name">' + esc(primary(kind, it)) + '</span><span class="nusa-pz-tile__meta">' + esc(sec || 'Código por confirmar') + '</span></button>';
    }).join('') : '<p class="nusa-pz-empty">No hay muestras con esos filtros. Prueba con otro nombre o código.</p>';
  }
  function openDrawer(kind, trigger) {
    lastFocus = trigger || document.activeElement; dr = { kind: kind, q: '', fam: '' };
    if (!drawer) {
      drawer = document.createElement('div'); drawer.className = 'nusa-pz-drawer'; drawer.setAttribute('role', 'dialog'); drawer.setAttribute('aria-modal', 'true');
      document.body.appendChild(drawer);
      drawer.addEventListener('click', onDrawerClick); drawer.addEventListener('input', onDrawerInput); drawer.addEventListener('keydown', onDrawerKey);
    }
    drawer.setAttribute('aria-label', TXT[kind].drawer);
    drawer.innerHTML = '<div class="nusa-pz-scrim" data-dr="close"></div><aside class="nusa-pz-panel" tabindex="-1">' +
      '<header class="nusa-pz-panel__head"><h3>' + TXT[kind].drawer + '</h3><button type="button" class="nusa-pz-x" data-dr="close" aria-label="Cerrar">&times;</button></header>' +
      '<p class="nusa-pz-panel__note">' + TXT[kind].note + '</p>' +
      '<div class="nusa-pz-filters"><label class="nusa-pz-sr" for="nusa-pz-q">Buscar</label><input id="nusa-pz-q" class="nusa-pz-search" type="search" autocomplete="off" placeholder="' + TXT[kind].search + '"><div class="nusa-pz-chips" data-chips></div></div>' +
      '<p class="nusa-pz-count" data-count aria-live="polite"></p><div class="nusa-pz-grid" data-grid></div></aside>';
    drawer.hidden = false; document.documentElement.classList.add('nusa-pz-lock');
    paintDrawer(); $('.nusa-pz-panel', drawer).focus();
  }
  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.hidden = true; document.documentElement.classList.remove('nusa-pz-lock');
    if (lastFocus && lastFocus.isConnected) lastFocus.focus();
  }
  function onDrawerClick(e) {
    var el = e.target.closest('[data-dr]'); if (!el) return;
    var a = el.dataset.dr;
    if (a === 'close') closeDrawer();
    else if (a === 'fam') { dr.fam = el.dataset.v; paintDrawer(); }
    else if (a === 'pick') { var kind = dr.kind, id = el.dataset.id; closeDrawer(); choose(kind, id, true); }
  }
  function onDrawerInput(e) { if (e.target.classList.contains('nusa-pz-search')) { dr.q = e.target.value; paintDrawer(); } }
  function onDrawerKey(e) {
    if (e.key === 'Escape') { e.stopPropagation(); closeDrawer(); return; }
    if (e.key !== 'Tab') return;
    var f = $$('button, input, [tabindex="0"]', drawer).filter(function (x) { return !x.disabled && x.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === $('.nusa-pz-panel', drawer))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------------- elegir ---------------- */
  function choose(kind, id, fromDrawer) {
    var it = find(kind, id); if (!it) return;
    S[kind] = S[kind] === id ? null : id;
    if (kind !== 'alu') lastPhoto = S[kind] ? kind : (lastPhoto === kind ? null : lastPhoto);
    refresh(kind, fromDrawer ? null : id);
    if (fromDrawer) { var b = $('[data-opt="' + kind + '"] .nusa-pz__dot[aria-pressed="true"], [data-opt="' + kind + '"] .nusa-pz__more', root); if (b) b.focus(); }
    afterChange(S[kind] ? { kind: kind, it: it } : null);
  }
  function setStruct(v) {
    S.st = S.st === v ? null : v;
    refresh('st', v); refresh('alu');
    afterChange(null);
  }
  function afterChange(picked) {
    var wa = $('[data-pz-wa]', root); if (wa) wa.href = waMain();
    syncFields(); syncURL(); updateInset(); syncStock();
    // en las piezas con vista previa, elegir algo vuelve a la foto principal y deja la galería fija para que se vea el cambio
    if (cfg.prev && wantsPreview()) { S.free = false; S.orig = false; goMain(); }
    syncLock(); renderPreview();
    if (picked) track(picked.kind, picked.it);
  }

  /* ---------------- eventos ---------------- */
  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-act]');
    if (t) {
      var a = t.dataset.act;
      if (a === 'pick') choose(t.dataset.kind, t.dataset.id, false);
      else if (a === 'open') openDrawer(t.dataset.kind, t);
      else if (a === 'struct') setStruct(t.dataset.v);
      return;
    }
    // nusa.js engancha los [data-track] solo al cargar la página; estos enlaces se vuelven a dibujar, por eso llevan sus propios atributos
    var tr = e.target.closest('[data-pz-track]');
    if (tr && window.dataLayer && typeof window.dataLayer.push === 'function') window.dataLayer.push({ event: tr.dataset.pzTrack, source: tr.dataset.pzSource, product: tr.dataset.pzProduct });
  });
  if (gal) gal.addEventListener('click', function (e) { if (e.target.closest('[data-gallery-thumb]')) setTimeout(setView, 0); });
  document.addEventListener('click', function (e) {
    if (cfg.struct === 'variant' && e.target.closest('[data-swatch]')) setTimeout(function () { refresh('alu'); syncFields(); syncURL(); updateInset(); syncStock(); syncLock(); var wa = $('[data-pz-wa]', root); if (wa) wa.href = waMain(); }, 0);
  });
  if (form) form.addEventListener('submit', function (e) {
    if (cfg.struct === 'choice' && !S.st) {
      e.preventDefault();
      var err = $('[data-err]', root); if (err) err.hidden = false;
      var box = $('[data-opt="st"]', root); if (box) { box.scrollIntoView({ behavior: 'smooth', block: 'center' }); var b = $('.nusa-pz__choice', box); if (b) b.focus({ preventScroll: true }); }
    }
  });

  /* ---------------- inicio ---------------- */
  root.innerHTML = blockHTML(); syncEmpty();
  // elección que viene en el enlace (?tela=58030-0000&aluminio=RX3177&cubierta=HI-036&estructura=aluminio)
  (function fromURL() {
    var p = new URLSearchParams(window.location.search), it;
    if (cfg.struct === 'choice' && (p.get('estructura') === 'teca' || p.get('estructura') === 'aluminio')) S.st = p.get('estructura');
    if (cfg.pal.indexOf('tela') >= 0 && (it = findAny('tela', p.get('tela')))) { S.tela = it.id; lastPhoto = 'tela'; }
    if (cfg.pal.indexOf('cer') >= 0 && (it = findAny('cer', p.get('cubierta')))) { S.cer = it.id; lastPhoto = lastPhoto || 'cer'; }
    if (cfg.pal.indexOf('alu') >= 0 && (it = findAny('alu', p.get('aluminio')))) S.alu = it.id;
  })();
  if (S.st || S.tela || S.cer || S.alu) { refreshAll(); syncFields(); updateInset(); syncStock(); syncLock(); renderPreview(); }
  // calienta el motor cuando el bloque se acerca a la pantalla, para que la primera elección salga rápido
  if (cfg.prev && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); setTimeout(function () { warm().catch(function () {}); }, 600); } }, { rootMargin: '300px' });
    io.observe(root);
  }
})();
